"use strict";
/**
 * @module Client
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The state of the internal session
 */
var InternalSessionState;
(function (InternalSessionState) {
    InternalSessionState["INITIALISING"] = "initialising";
    InternalSessionState["CONNECTING"] = "connecting";
    InternalSessionState["CONNECTED"] = "connected";
    InternalSessionState["DISCONNECTED"] = "disconnected";
    InternalSessionState["RECONNECTING"] = "reconnecting";
    InternalSessionState["CLOSING"] = "closing";
    InternalSessionState["CLOSED"] = "closed";
})(InternalSessionState = exports.InternalSessionState || (exports.InternalSessionState = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/internal-session.js
// module id = 509
// module chunks = 1